import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// 🔹 Get all course purchases
export const getCoursePurchases = createAsyncThunk(
  "admin/allCoursePurchases",
  async ({ page, limit, searchData, courseId }, { rejectWithValue }) => {
    try {
      let url = `/course-purchase/all?page=${page}&limit=${limit}`;
      if (searchData) url += `&search=${searchData}`;
      if (courseId) {
        url += `&courseFilter=${courseId}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Get single course purchase
export const getSingleCoursePurchase = createAsyncThunk(
  "admin/singleCoursePurchase",
  async (purchaseId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/course-purchase/${purchaseId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Edit course purchase
export const editCoursePurchase = createAsyncThunk(
  "admin/editCoursePurchase",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/course-purchase/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Delete course purchase
export const deleteCoursePurchase = createAsyncThunk(
  "admin/deleteCoursePurchase",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/course-purchase/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getCoursePurchasesBill = createAsyncThunk(
  "admin/CoursePurchasesBill",
  async ({ courseId }, { rejectWithValue }) => {
    try {
      let url = `/course-purchase/bill/generate`;
      if (courseId) {
        url += `?coursePurchaseId=${courseId}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  coursePurchaseData: [],
  singleCoursePurchase: {},
  coursePurchaseBillData: ""
};

const coursePurchaseSlice = createSlice({
  name: "coursePurchaseSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoursePurchases.fulfilled, (state, action) => {
      state.coursePurchaseData = action.payload.data;
    });
    builder.addCase(getSingleCoursePurchase.fulfilled, (state, action) => {
      state.singleCoursePurchase = action.payload.data;
    });
    builder.addCase(getCoursePurchasesBill.fulfilled, (state, action) => {
      state.coursePurchaseBillData = action.payload.data;
    });
  },
});

export default coursePurchaseSlice.reducer;
